export default "__VITE_ASSET__iQKh2DTL__"